<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">CREATE DEPARTMENT</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Department Title -->
    <div class="row">
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>Code</label>
          <input type="text" class="form-control" formControlName="code"
            [ngClass]="formErrorClass(createForm.controls.code, createFormSubmitted)">
            <span class="text-danger"
            *ngIf="(createForm.controls.code?.touched || createFormSubmitted) && createForm.controls.code?.errors?.required">
            This field is required.
          </span>                
        </div>
      </div>
      <!-- Department description -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-12">
          <label>Description</label>
          <textarea class="form-control" formControlName="description"
            [ngClass]="formErrorClass(createForm.controls.description, createFormSubmitted)"></textarea>
            <span class="text-danger"
            *ngIf="(createForm.controls.description?.touched || createFormSubmitted) && createForm.controls.description?.errors?.required">
            This field is required.
          </span>              
        </div>
      </div>


    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ generalLang.save }}</button>
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ generalLang.close }}</button>
  </div>
</form>
